import React from 'react';
import PropTypes from 'prop-types';
import { Icons } from '@techsoftware/happay-widgets';
import happayLogo from '../../assets/images/happay-1000-x-1000.svg';
import history from '../../utils/history';
const CollapseRightArrow = props => (
  <div
    className="padding-l-20 padding-r-20 bottom-nav-toggle"
    // onMouseOver={props.isOpen ? props.onMouseOver : ''}
    // onMouseOver={props.onMouseOver}
    // onMouseLeave={props.onMouseLeave}
    // onMouseLeave={(!props.isCollapsed && !props.isOpen) ? '' : props.onMouseLeave}
  >
    <div className="right-arrow padding-t-20">
      {!props.isOpen ? (
        <img
          height="20px"
          src={happayLogo}
          onClick={() => history.push('/dashboard')}
          className="padding-r-60 pointer"
          alt="happay logo"
        />
      ) : null}
      <div
        className={
          props.isOpen ? 'right-arrow--zone' : 'right-arrow--zone collapsed'
        }
        onClick={props.handleToggle}
      >
        <Icons
          className="white-color"
          rotate={props.isOpen ? 180 : 0}
          type="navarrow-left"
        />
      </div>
    </div>
  </div>
);

CollapseRightArrow.propTypes = {
  isOpen: PropTypes.bool,
  // isCollapsed: PropTypes.bool,
  // style: PropTypes.object,
  // onMouseOver: PropTypes.func,
  // onMouseLeave: PropTypes.func,
  handleToggle: PropTypes.func,
};

CollapseRightArrow.defaultProps = {
  isOpen: false,
  // onMouseOver: () => {},
  // onMouseLeave: () => {},
  handleToggle: () => {},
  // isCollapsed: false,
};

export default CollapseRightArrow;
